import React from 'react';
import API from '../../configAPI';
import APP_CONFIG from '../../config';
import BarLoader from 'react-spinners/BarLoader';
class FormRequest extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            full_name: '',
            company: '',
            position: '',
            email: '',
            phone: '',
            message: `Solicito más información sobre ${this.props.product_name}`,
            is_submit: false,
            message_response: 'Server response',
            loading: false
        }

    }

    handleChange = (e) =>{
        this.setState({
            [e.target.name] : e.target.value
        });
    }
    handleSubmit = (e) =>{
        this.setState({loading: true});
        e.preventDefault();
        API.PRODUCTS.post('product-quotation',{
            full_name: this.state.full_name,
            company: this.state.company,
            position: this.state.position,
            email: this.state.email,
            phone: this.state.phone,
            message: this.state.message,
            product_id: this.props.product_id
        })
        .then(resp =>{
            // window.alert(resp.data.message);
            this.setState({
                is_submit : true,
                message_response: resp.data.message,
                loading: false
            });
        })
        .catch(err =>{
            console.log(err);
        });
    }

    render(){
        return (
            <section className="col-12">
                
                <div className="d-inline">
                <h5>Cotizar producto</h5>
                <BarLoader
                    width={100}
                    height={4}
                    color={APP_CONFIG.spinner_color}
                    loading={this.state.loading}
                />
                </div>
                {!this.state.is_submit ?
                <form action="#" method="post" className="mt-3" onSubmit={this.handleSubmit}>
                    <div className="form-group">              
                    <input onChange={this.handleChange} type="text" className="form-control" name="full_name" 
                    placeholder="Ingrese nombres y apellidos" required/>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-md-6">
                        <div className="form-group">             
                            <input onChange={this.handleChange} type="text" className="form-control" name="company" placeholder="Empresa (opcional)"/>
                        </div>
                        </div>
                        <div className="col-xs-12 col-md-6">
                        <div className="form-group">             
                            <input onChange={this.handleChange} type="text" className="form-control" name="position"  placeholder="Cargo (opcional)"/>
                        </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-md-8">
                            <div className="form-group">             
                                <input onChange={this.handleChange} type="email" className="form-control" name="email" placeholder="Correo electrónico"/>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-4">
                            <div className="form-group">             
                                <input onChange={this.handleChange} type="text" className="form-control" name="phone" placeholder="N° celular"/>
                            </div>
                        </div>
                    </div>

                    <div className="form-group">                
                    <textarea onChange={this.handleChange} name="message" className="form-control" rows="3" defaultValue={this.state.message}></textarea>
                    </div>
                    <button type="submit" className="btn btn-dark btn-block">Enviar</button>
                </form>
                :
                <div className="alert alert-success" role="alert">
                    {this.state.message_response} <span className="fa fa-check float-right"></span>
                </div>
                }
            </section>
        )
    }
}

export default FormRequest;